
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 5732"}},[_c('path',{attrs:{"data-name":"Path 194","d":"M56.1 0H7.9A1.87 1.87 0 006 1.87v60.25A1.86 1.86 0 007.9 64a1.89 1.89 0 00.84-.2L32 52.17 55.26 63.8a1.88 1.88 0 002.52-.8 1.73 1.73 0 00.19-.84V1.87A1.87 1.87 0 0056.1 0zM45.36 24L40 29.22l1.24 7.21a1.88 1.88 0 01-1.42 2.24 1.84 1.84 0 01-.41 0 1.89 1.89 0 01-.87-.21L32 35.05l-6.58 3.45a1.88 1.88 0 01-2.53-.78 1.92 1.92 0 01-.19-1.2L24 29.2 18.64 24a1.88 1.88 0 010-2.65 1.94 1.94 0 011.08-.55L27 19.76l3.29-6.68a1.88 1.88 0 012.51-.86 1.91 1.91 0 01.85.86L37 19.76l7.35 1.06A1.89 1.89 0 0145.91 23a1.85 1.85 0 01-.55 1z"}})])])
          )
        }
      }
    